import React from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";

import { AuthUserContext, withAuthorization } from "../../Auth/Session";

import * as constantsCity from "../../../constants/actions/Cities";
import * as APIS from "../../../constants/apis";

function getCity(id, t) {
  return dispatch => {
    return trackPromise(fetch(`${APIS.API_REST_CITIES.replace("customer_id",
                 localStorage.getItem("GlobalCustomerId"))}/${id}`, {
                  headers:{
                    "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
                    "Accept-language": localStorage.getItem("LanguageSelected"),
                  } })
      .then(response => {
        if(response.status !== 200) {
          throw new Error(t("alerts.cities-item-4"));
        }
        return response.json(); })
      .then(json => {
        dispatch(getCitySuccess({
          city     : json
        })); })
      .catch(error => {
        toast.error(error.message.toString());
      }));
  }
}

export function getCitySuccess(json) {
  return {
    type: constantsCity.GET_CITY_SUCCESS,
    json
  }
}

export function getReqSuccess(cities, city, message) {
  const json = {
    cities    : cities,
    city      : city,
    message   : message
  };
  return {
    type: constantsCity.GET_REQUEST_SUCCESS,
    json
  };
};

class CityEditItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      // code: ""
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.getCity(id, this.props.t);
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.city || (this.props.city !== prevProps.city)) {
      this.setState({
        customer_id : this.props.city.customer_id,
        name        : this.props.city.name,
        // code        : this.props.city.code
      });
    }
  }

  onSubmit = event => {
    event.preventDefault();
    const { getReqSuccess, city, cities } = this.props;

    const id = this.props.match.params.id;
    const data = {
      ...this.state,
    };

    if(city.id === data.id && city.code === data.code) {
      this.props.history.push("/cities");
      getReqSuccess(cities, city, this.props.t("alerts.cities-item-5"));
      return Promise.resolve();
    }

    return trackPromise(fetch(`${APIS.API_REST_CITIES.replace("customer_id",
                                                 localStorage.getItem("GlobalCustomerId"))}/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers:{
          "Content-Type": "application/json",
          "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
          "Accept-language": localStorage.getItem("LanguageSelected"),
        } })
      .then(response => response.json())
      .then(json => {
        const status = json.message;
        if(!status) {
          this.props.history.push("/cities");
          getReqSuccess(cities, city, this.props.t("alerts.cities-item-5"));
        } else {
          throw new Error(status);
        } })
      .catch(error => {
        toast.error(error.toString());
      }));
  };

  onChange = event =>{
    this.setState({ [event.target.name]: event.target.value });
  };

  showSuccessDialog = (message) => {
    if(!!message && !!toast) {
      toast.success(message);
    }
  };

  showErrorDialog = (error) => {
    if(!!error && !!toast) {
      toast.error(error);
    }
  };

  render () {
    const { city, message, error } = this.props;

    this.showErrorDialog(error);
    this.showSuccessDialog(message);
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          !!city ?
          <div className="container-fluid mt-100">
            
            <h3>{this.props.t("client-general.cities-edit")}</h3>
            <br/><br/>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="nameInput">{this.props.t("client-general.client-item-1")}</label>
                    <br></br><i className="text-info small">{this.props.t("globals.required")}</i>
                  </div>
                  <div className="col-sm-10">
                    <input className="form-control"
                           placeholder={this.props.t("client-general.client-item-1")}
                           id="nameInput"
                           name="name"
                           value={this.state.name}
                           onChange={this.onChange}
                           required />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <button type="submit"
                          className="btn btn-primary">
                    <i className="fa fa-save"/><i/> {this.props.t("globals.simple-save")}
                  </button>
                </div>
              </div>
            </form>
          </div> : null
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const structuredSelector = createStructuredSelector({
  cities    : state => state.cities,
  city      : state => state.city,
  message   : state => state.message,
  error     : state => state.error
});

const mapDispatchToProps = { getCity, getReqSuccess };

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(connect(structuredSelector, mapDispatchToProps)(CityEditItem));
